/**
 * 根据 URL 判断扩展类型
 * @param {*} url 图片 url
 */
export function getUrlExtension(url: string): string {
    const imageNameArr = url.split('?')?.shift()
        ?.split('/')
        ?.pop()
        ?.split('.');
    if (imageNameArr && imageNameArr?.length >= 2) return imageNameArr[imageNameArr?.length - 1];
    return '';
}
